import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/scss/sections/_choose.scss';

const ChooseUs = ({ setting_data }) => {
  return (
    <>
      <section id="choose_us">
        <Container className="choose_plus">
          <h3 className="main_common_title choose_us_title text-center">
            <span className="common_span"> {setting_data?.home_page_why_choose_us_title_1}</span>
            {setting_data?.home_page_why_choose_us_title_2}
          </h3>
          <Row>
            <Col>
              <div className="choose_us_wrapper">
                <p className="choose_us_content">
                  {Parser(setting_data?.home_page_why_choose_us_text)}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
ChooseUs.propTypes = {
  setting_data: PropTypes.object,
};
export { ChooseUs };
